module.exports = {
    slideSettings: {

        erschoepfung_aloevera_trinkgel_alle_sorten: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'erschoepfung',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-1_4_Erschoepfung/Produkte/LR-anwendungsgebiete_ERSCHOEPFUNG2.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-1_4_Erschoepfung/Produkte/LR-anwendungsgebiete_ERSCHOEPFUNG3.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-1_4_Erschoepfung/Produkte/LR-anwendungsgebiete_ERSCHOEPFUNG4.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-1_4_Erschoepfung/Produkte/LR-anwendungsgebiete_ERSCHOEPFUNG5.jpg'
                }
            ]
        },

        stress_mind_master_green_und_red: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'stress',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-1_5_Stress/Produkte/LR-anwendungsgebiete_STRESS2.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-1_5_Stress/Produkte/LR-anwendungsgebiete_STRESS3.jpg'
                },
            ]
        },

        allergien_trinkgele: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'allergien',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-2_1_Allergien/Produkte/LR-anwendungsgebiete_ALLERGIEN2.jpg',
                    infoImage: 'allergien_trinkgele_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-2_1_Allergien/Produkte/LR-anwendungsgebiete_ALLERGIEN3.jpg',
                    infoImage: 'allergien_trinkgele_2_images'
                },
            ]
        },

        allergien_trinkgele_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'allergien_trinkgele',
            slides: [
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten2.jpg'
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten5.jpg'
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten9.jpg'
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten10.jpg'
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten11.jpg'
                }
            ]
        },

        allergien_trinkgele_2_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'allergien_trinkgele',
            slides: [
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten2.jpg'
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten5.jpg'
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten9.jpg'
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten10.jpg'
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten11.jpg'
                }
            ]
        },


        allergien_trockene_haut: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'allergien',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-2_1_Allergien/Produkte/LR-anwendungsgebiete_ALLERGIEN7.jpg',
                    infoImage: 'allergien_trockene_haut_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-2_1_Allergien/Produkte/LR-anwendungsgebiete_ALLERGIEN8.jpg',
                    infoImage: 'allergien_trockene_haut_2_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-2_1_Allergien/Produkte/LR-anwendungsgebiete_ALLERGIEN9.jpg',
                    infoImage: 'allergien_trockene_haut_3_images'
                },
            ]
        },

        allergien_trockene_haut_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'allergien_trockene_haut',
            slides: [
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten.jpg'
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten4.jpg'
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten6.jpg'
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten9.jpg'
                }
            ]
        },

        allergien_trockene_haut_2_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'allergien_trockene_haut',
            slides: [
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten.jpg'
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten2.jpg'
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten3.jpg'
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten5.jpg'
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten8.jpg'
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten9.jpg'
                }
            ]
        },

        allergien_trockene_haut_3_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'allergien_trockene_haut',
            slides: [
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten4.jpg'
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten6.jpg'
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten7.jpg'
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten8.jpg'
                }
            ]
        },



        allergien_spezial_sonnenpflege: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'allergien',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-2_1_Allergien/Produkte/LR-anwendungsgebiete_ALLERGIEN10.jpg',
                    infoImage: 'allergien_spezial_sonnenpflege_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-2_1_Allergien/Produkte/LR-anwendungsgebiete_ALLERGIEN11.jpg',
                },
            ]
        },

        allergien_spezial_sonnenpflege_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'allergien_spezial_sonnenpflege',
            slides: [
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten9.jpg'
                }
            ]
        },

        allergien_hautpflege_allgemein: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'allergien',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-2_1_Allergien/Produkte/LR-anwendungsgebiete_ALLERGIEN13.jpg',
                    infoImage: 'allergien_hautpflege_allgemein_1_images'
                },
            ]
        },

        allergien_hautpflege_allgemein_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'allergien_hautpflege_allgemein',
            slides: [
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten6.jpg'
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten11.jpg'
                }
            ]
        },

        verletzungen_notfallspray: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'verletzungen',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-2_2_Verletzungen/Produkte/LR-anwendungsgebiete_VERLETZUNGEN3.jpg',
                    infoImage: 'verletzungen_notfallspray_1_images'
                }
            ]
        },

        verletzungen_notfallspray_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'verletzungen_notfallspray',
            slides: [
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten.jpg',
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten4.jpg',
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten6.jpg',
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten9.jpg',
                }
            ]
        },

        verletzungen_concentrat: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'verletzungen',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-2_2_Verletzungen/Produkte/LR-anwendungsgebiete_VERLETZUNGEN4.jpg',
                    infoImage: 'verletzungen_concentrat_1_images'
                }
            ]
        },

        verletzungen_concentrat_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'verletzungen_concentrat',
            slides: [
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten.jpg',
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten2.jpg',
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten3.jpg',
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten5.jpg',
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten6.jpg',
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten8.jpg',
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten9.jpg',
                }
            ]
        },

        verletzungen_propolis_creme: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'verletzungen',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-2_2_Verletzungen/Produkte/LR-anwendungsgebiete_VERLETZUNGEN5.jpg',
                    infoImage: 'verletzungen_propolis_creme_1_images'
                }
            ]
        },

        verletzungen_propolis_creme_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'verletzungen_propolis_creme',
            slides: [
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten4.jpg',
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten6.jpg',
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten7.jpg',
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten8.jpg',
                }
            ]
        },


        immunsystem_aloevera_trinkgel_honey: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'immunsystem',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-1_1_Ein_kraftvolles_Immunssystem/Produkte/Immunssystem_AloeVera_Tinkgel_Honey_seite02.jpg',
                    infoImage: 'immunsystem_aloevera_trinkgel_honey_1_images'
                }
            ]
        },

        immunsystem_aloevera_trinkgel_honey_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'immunsystem_aloevera_trinkgel_honey',
            slides: [
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten2.jpg',
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten5.jpg',
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten9.jpg',
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten10.jpg',
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten11.jpg',
                },
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten6.jpg',
                }
            ]
        },

        immunsystem_cistus_kapseln: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'immunsystem',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-1_1_Ein_kraftvolles_Immunssystem/Produkte/LR-anwendungsgebiete_IMMUNSYSTEM-seite03.jpg',
                    infoImage: 'immunsystem_cistus_kapseln_1_images'
                }
            ]
        },

        immunsystem_cistus_kapseln_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'immunsystem_cistus_kapseln',
            slides: [
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten3.jpg',
                },
            ]
        },

        immunsystem_cistus_incanus_tee: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'immunsystem',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-1_1_Ein_kraftvolles_Immunssystem/Produkte/LR-anwendungsgebiete_IMMUNSYSTEM_cistusincanus-tee.jpg',
                    infoImage: 'immunsystem_cistus_incanus_tee_1_images'
                }
            ]
        },

        immunsystem_cistus_incanus_tee_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'immunsystem_cistus_incanus_tee',
            slides: [
                {
                    type: 'image',
                    path: 'data/vorher_nachher/LR-vorher-nachher-seiten3.jpg',
                },
            ]
        },









        kemmernews: {
            backDestinationName: 'root',
            backDestinationParam: '',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-2_5_KemmerNews/Kemmer-News.jpg'
                }
            ]
        },


        bodymission: {
            backDestinationName: 'root',
            backDestinationParam: '',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_4_Body_Mission/Produkte/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE24.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_4_Body_Mission/Produkte/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE25.jpg'
                }
            ]
        },



        hydroalcoholic: {
            backDestinationName: 'root',
            backDestinationParam: '',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-4_4_Protection/2_produktseite_HYDRO-ALCOHOLIC-handspray1.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-4_4_Protection/3_produktseite_HYDRO-ALCOHOLIC-handspray2.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-4_4_Protection/4_produktseite_HYDRO-ALCOHOLIC-handspray3.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-4_4_Protection/5_produktseite_HYDRO-ALCOHOLIC-handspray4.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-4_4_Protection/6_produktseite_HYDRO-ALCOHOLIC-handspray5.jpg'
                }
            ]
        },




        fuerjedelebenslage_daily_essentials: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'fuerjedelebenslage',
            // infoImage: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Daily Essentials/Info/2_LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE05.jpg',
            infoImage: 'fuerjedelebenslage_daily_essentials_images',
            infoVideo: 'fuerjedelebenslage_daily_essentials_videos',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Daily Essentials/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE02.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Daily Essentials/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE03.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Daily Essentials/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE04.jpg'
                }
            ]
        },

        fuerjedelebenslage_daily_essentials_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'fuerjedelebenslage_daily_essentials',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Daily Essentials/Info/2_LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE05.jpg'
                }
            ]
        },

        fuerjedelebenslage_mental_power: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'fuerjedelebenslage',
            // infoImage: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Mental Power/Info/2_LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE09.jpg',
            infoImage: 'fuerjedelebenslage_mental_power_images',
            infoVideo: 'fuerjedelebenslage_mental_power_videos',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Mental Power/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE06.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Mental Power/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE07.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Mental Power/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE08.jpg'
                }
            ]
        },

        fuerjedelebenslage_mental_power_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'fuerjedelebenslage_daily_essentials',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Mental Power/Info/2_LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE09.jpg'
                }
            ]
        },

        fuerjedelebenslage_seasonal_support: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'fuerjedelebenslage',
            // infoImage: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Seasonal Support/Info/2_LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE13.jpg',
            infoImage: 'fuerjedelebenslage_seasonal_support_images',
            infoVideo: 'fuerjedelebenslage_seasonal_support_videos',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Seasonal Support/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE10.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Seasonal Support/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE11.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Seasonal Support/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE12.jpg'
                }
            ]
        },

        fuerjedelebenslage_seasonal_support_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'fuerjedelebenslage_seasonal_support',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Seasonal Support/Info/2_LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE13.jpg'
                }
            ]
        },

        fuerjedelebenslage_pro_activity: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'fuerjedelebenslage',
            // infoImage: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Pro Activity/Info/2_LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE17.jpg',
            infoImage: 'fuerjedelebenslage_pro_activity_images',
            infoVideo: 'fuerjedelebenslage_pro_activity_videos',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Pro Activity/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE14.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Pro Activity/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE15.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Pro Activity/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE16.jpg'
                }
            ]
        },

        fuerjedelebenslage_pro_activity_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'fuerjedelebenslage_pro_activity',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Pro Activity/Info/2_LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE17.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Pro Activity/Info/3_LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE18.jpg'
                }
            ]
        },

        fuerjedelebenslage_vital_care: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'fuerjedelebenslage',
            // infoImage: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Vital Care/Info/2_LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE22.jpg',
            infoImage: 'fuerjedelebenslage_vital_care_images',
            infoVideo: 'fuerjedelebenslage_vital_care_videos',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Vital Care/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE19.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Vital Care/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE20.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Vital Care/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE21.jpg'
                }
            ]
        },

        fuerjedelebenslage_vital_care_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'fuerjedelebenslage_vital_care',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Vital Care/Info/2_LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE22.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Vital Care/Info/3_LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE23.jpg'
                }
            ]
        },

        fuerjedelebenslage_body_mission: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'fuerjedelebenslage',
            // infoImage: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Body Mission/Info/2_LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE28.jpg',
            infoImage: 'fuerjedelebenslage_body_mission_images',
            infoVideo: 'fuerjedelebenslage_body_mission_videos',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Body Mission/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE24.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Body Mission/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE25.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Body Mission/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE26.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Body Mission/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE27.jpg'
                }
            ]
        },

        fuerjedelebenslage_body_mission_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'fuerjedelebenslage_body_mission',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Body Mission/Info/2_LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE28.jpg'
                }
            ]
        },

        fuerjedelebenslage_true_beauty: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'fuerjedelebenslage',
            // infoImage: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/True Beauty/Info/2_LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE34.jpg',
            infoImage: 'fuerjedelebenslage_true_beauty_images',
            infoVideo: 'fuerjedelebenslage_true_beauty_videos',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/True Beauty/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE29.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/True Beauty/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE30.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/True Beauty/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE31.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/True Beauty/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE32.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/True Beauty/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE33.jpg'
                }
            ]
        },

        fuerjedelebenslage_true_beauty_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'fuerjedelebenslage_true_beauty',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/True Beauty/Info/2_LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE34.jpg'
                }
            ]
        },

        fuerjedelebenslage_night_essentials: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'fuerjedelebenslage',
            infoImage: 'fuerjedelebenslage_night_essentials_images',
            infoVideo: 'fuerjedelebenslage_night_essentials_videos',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Night Essentials/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE35.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Night Essentials/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE36.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Night Essentials/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE37.jpg'
                },
            ]
        },

        fuerjedelebenslage_night_essentials_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'fuerjedelebenslage_night_essentials',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Night Essentials/Info/2_LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE38.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Night Essentials/Info/2_LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE38_1.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Night Essentials/Info/2_LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE38_2.jpg'
                }
            ]
        },

        fuerjedelebenslage_5in1_mensshot: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'fuerjedelebenslage',
            infoImage: 'fuerjedelebenslage_5in1_mensshot_images',
            infoVideo: 'fuerjedelebenslage_5in1_mensshot_videos',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/5in1 Mens Shot/LR-LIFETAKT_5in1_mens-shot.jpg'
                }
            ]
        },

        fuerjedelebenslage_5in1_mensshot_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'fuerjedelebenslage_5in1_mensshot',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/5in1 Mens Shot/LR-LIFETAKT_5in1_mens-shot2.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/5in1 Mens Shot/LR-LIFETAKT_5in1_mens-shot3.jpg'
                }
            ]
        },

        fuerjedelebenslage_cell_essence: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'fuerjedelebenslage',
            infoImage: 'fuerjedelebenslage_cell_essence_images',
            infoVideo: 'fuerjedelebenslage_cell_essence_videos',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Cell Essence/LR-LIFETAKT_cell-essece.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Cell Essence/LR-LIFETAKT_cell-essece2.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Cell Essence/LR-LIFETAKT_cell-essece3.jpg',
                }
            ]
        },

        fuerjedelebenslage_cell_essence_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'fuerjedelebenslage_cell_essence',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Cell Essence/LR-LIFETAKT_cell-essece4.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Cell Essence/LR-LIFETAKT_cell-essece5.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Cell Essence/LR-LIFETAKT_cell-essece6.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Cell Essence/LR-LIFETAKT_cell-essece7.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Cell Essence/LR-LIFETAKT_cell-essece8.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Cell Essence/LR-LIFETAKT_cell-essece9.jpg'
                }
            ]
        },

        fuerjedelebenslage_cannaloe: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'fuerjedelebenslage',
            infoImage: 'fuerjedelebenslage_cannaloe_images',
            infoVideo: 'fuerjedelebenslage_cannaloe_videos',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Cannaloe/LR-LIFETAKT_seiten_CANNALOE2.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Cannaloe/LR-LIFETAKT_seiten_CANNALOE3.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Cannaloe/LR-LIFETAKT_seiten_CANNALOE4.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Cannaloe/LR-LIFETAKT_seiten_CANNALOE5.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Cannaloe/LR-LIFETAKT_seiten_CANNALOE6.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Cannaloe/LR-LIFETAKT_seiten_CANNALOE7.jpg',
                }
            ]
        },

        fuerjedelebenslage_cannaloe_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'fuerjedelebenslage_cannaloe',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/Cannaloe/LR-LIFETAKT_seiten_CANNALOE.jpg'
                }
            ]
        },

        fuerjedelebenslage_lr_lifetakt_konzept: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'fuerjedelebenslage',
            infoVideo: 'fuerjedelebenslage_lr_lifetakt_konzept_videos',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/LR Lifetakt Konzept/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE39.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Produkte/LR Lifetakt Konzept/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_SEITE40.jpg'
                }
            ]
        },

        einzelneprodukte_aloe_vera_drinking_gel: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'einzelneprodukte',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/AloeVera Drinking Gel/Aloe_Vera_Drinking_Gel-1.jpg',
                    infoImage: 'einzelneprodukte_aloe_vera_drinking_gel_1_images',
                    infoVideo: 'einzelneprodukte_aloe_vera_drinking_gel_1_videos',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/AloeVera Drinking Gel/Aloe_Vera_Drinking_Gel-2.jpg',
                    infoImage: 'einzelneprodukte_aloe_vera_drinking_gel_2_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/AloeVera Drinking Gel/Aloe_Vera_Drinking_Gel-3.jpg',
                    infoImage: 'einzelneprodukte_aloe_vera_drinking_gel_3_images'
                }
            ]
        },

        einzelneprodukte_aloe_vera_drinking_gel_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_aloe_vera_drinking_gel',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/AloeVera Drinking Gel/Aloe_Vera_Drinking_Gel-1_2.jpg'
                }
            ]
        },

        einzelneprodukte_aloe_vera_drinking_gel_2_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_aloe_vera_drinking_gel',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/AloeVera Drinking Gel/Aloe_Vera_Drinking_Gel-2_1.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/AloeVera Drinking Gel/Aloe_Vera_Drinking_Gel-2_2.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/AloeVera Drinking Gel/Aloe_Vera_Drinking_Gel-2_3.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/AloeVera Drinking Gel/Aloe_Vera_Drinking_Gel-2_4.jpg'
                }
            ]
        },

        einzelneprodukte_aloe_vera_drinking_gel_3_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_aloe_vera_drinking_gel',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/AloeVera Drinking Gel/Aloe_Vera_Drinking_Gel-3_1.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/AloeVera Drinking Gel/Aloe_Vera_Drinking_Gel-3_2.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/AloeVera Drinking Gel/Aloe_Vera_Drinking_Gel-3_3.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/AloeVera Drinking Gel/Aloe_Vera_Drinking_Gel-3_4.jpg'
                }
            ]
        },

        einzelneprodukte_mind_master: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'einzelneprodukte',
            infoVideo: 'einzelneprodukte_mind_master_videos',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Mind Master/LR-LIFETAKT_einzelne-produkte14.jpg',
                    infoImage: 'einzelneprodukte_mind_master_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Mind Master/LR-LIFETAKT_einzelne-produkte17.jpg',
                    infoImage: 'einzelneprodukte_mind_master_2_images'
                }
            ]
        },

        einzelneprodukte_mind_master_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_mind_master',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Mind Master/LR-LIFETAKT_einzelne-produkte15.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Mind Master/LR-LIFETAKT_einzelne-produkte16.jpg'
                }
            ]
        },

        einzelneprodukte_mind_master_2_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_mind_master',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Mind Master/LR-LIFETAKT_einzelne-produkte18.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Mind Master/LR-LIFETAKT_einzelne-produkte19.jpg'
                }
            ]
        },

        einzelneprodukte_cistus_incanus: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'einzelneprodukte',
            infoVideo: 'einzelneprodukte_cistus_incanus_videos',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Cistus Incanus/LR-LIFETAKT_einzelne-produkte20.jpg',
                    infoImage: 'einzelneprodukte_cistus_incanus_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Cistus Incanus/LR-LIFETAKT_einzelne-produkte_Seite20_1.jpg',
                    infoImage: 'einzelneprodukte_cistus_incanus_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Cistus Incanus/LR-LIFETAKT_einzelne-produkte_Seite20_2.jpg',
                    infoImage: 'einzelneprodukte_cistus_incanus_1_images'
                }
            ]
        },

        einzelneprodukte_cistus_incanus_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_cistus_incanus',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Cistus Incanus/LR-LIFETAKT_einzelne-produkte21.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Cistus Incanus/LR-LIFETAKT_einzelne-produkte22.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Cistus Incanus/LR-LIFETAKT_einzelne-produkte23.jpg'
                }
            ]
        },

        einzelneprodukte_colostrum: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'einzelneprodukte',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Colostrum/LR-LIFETAKT_einzelne-produkte23.jpg',
                    infoImage: 'einzelneprodukte_colostrum_1_images'
                }
            ]
        },

        einzelneprodukte_colostrum_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_colostrum',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Colostrum/LR-LIFETAKT_einzelne-produkte24.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Colostrum/LR-LIFETAKT_einzelne-produkte25.jpg'
                }
            ]
        },

        einzelneprodukte_pro12: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'einzelneprodukte',
            infoVideo: 'einzelneprodukte_pro12_videos',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Pro 12/LR-LIFETAKT_einzelne-produkte26.jpg',
                    infoImage: 'einzelneprodukte_pro12_1_images'
                }
            ]
        },

        einzelneprodukte_pro12_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_pro12',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Pro 12/LR-LIFETAKT_einzelne-produkte27.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Pro 12/LR-LIFETAKT_einzelne-produkte28.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Pro 12/LR-LIFETAKT_einzelne-produkte28_1.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Pro 12/LR-LIFETAKT_einzelne-produkte28_2.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Pro 12/LR-LIFETAKT_einzelne-produkte28_3.jpg'
                }
            ]
        },

        einzelneprodukte_vita_activ: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'einzelneprodukte',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Vita Aktiv/LR-LIFETAKT_einzelne-produkte29.jpg',
                    infoImage: 'einzelneprodukte_vita_activ_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Vita Aktiv/LR-LIFETAKT_einzelne-produkte29_1.jpg',
                    infoImage: 'einzelneprodukte_vita_activ_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Vita Aktiv/LR-LIFETAKT_einzelne-produkte29_2.jpg',
                    infoImage: 'einzelneprodukte_vita_activ_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Vita Aktiv/LR-LIFETAKT_einzelne-produkte29_3.jpg',
                    infoImage: 'einzelneprodukte_vita_activ_1_images'
                }
            ]
        },

        einzelneprodukte_vita_activ_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_vita_activ',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Vita Aktiv/LR-LIFETAKT_einzelne-produkte30.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Vita Aktiv/LR-LIFETAKT_einzelne-produkte31.jpg'
                }
            ]
        },

        einzelneprodukte_reishi_plus: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'einzelneprodukte',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/reishi Plus/LR-LIFETAKT_einzelne-produkte32.jpg',
                    infoImage: 'einzelneprodukte_reishi_plus_1_images'
                }
            ]
        },

        einzelneprodukte_reishi_plus_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_reishi_plus',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/reishi Plus/LR-LIFETAKT_einzelne-produkte33.jpg'
                }
            ]
        },

        einzelneprodukte_active_freedom_kapseln: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'einzelneprodukte',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Active Freedom Kapseln/LR-LIFETAKT_einzelne-produkte34.jpg',
                    infoImage: 'einzelneprodukte_active_freedom_kapseln_1_images'
                }
            ]
        },

        einzelneprodukte_active_freedom_kapseln_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_active_freedom_kapseln',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Active Freedom Kapseln/LR-LIFETAKT_einzelne-produkte35.jpg'
                }
            ]
        },

        einzelneprodukte_super_omega: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'einzelneprodukte',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Super Omega/LR-LIFETAKT_einzelne-produkte36.jpg',
                    infoImage: 'einzelneprodukte_super_omega_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Super Omega/LR-LIFETAKT_einzelne-produkte36_1.jpg',
                    infoImage: 'einzelneprodukte_super_omega_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Super Omega/LR-LIFETAKT_einzelne-produkte36_2.jpg',
                    infoImage: 'einzelneprodukte_super_omega_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Super Omega/LR-LIFETAKT_einzelne-produkte36_3.jpg',
                    infoImage: 'einzelneprodukte_super_omega_1_images'
                }
            ]
        },

        einzelneprodukte_super_omega_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_super_omega',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Super Omega/LR-LIFETAKT_einzelne-produkte37.jpg'
                }
            ]
        },

        einzelneprodukte_woman_phyto: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'einzelneprodukte',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Woman Phyto/LR-LIFETAKT_einzelne-produkte38.jpg',
                    infoImage: 'einzelneprodukte_woman_phyto_1_images'
                }
            ]
        },

        einzelneprodukte_woman_phyto_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_woman_phyto',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Woman Phyto/LR-LIFETAKT_einzelne-produkte39.jpg'
                }
            ]
        },

        einzelneprodukte_fiber_boost: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'einzelneprodukte',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Fiber Boost/LR-LIFETAKT_einzelne-produkte40.jpg',
                    infoImage: 'einzelneprodukte_fiber_boost_1_images'
                }
            ]
        },

        einzelneprodukte_fiber_boost_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_fiber_boost',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Fiber Boost/LR-LIFETAKT_einzelne-produkte41.jpg'
                }
            ]
        },

        einzelneprodukte_herbal_fasting_tea: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'einzelneprodukte',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Herbal Fasting Tea/LR-LIFETAKT_einzelne-produkte42.jpg',
                    infoImage: 'einzelneprodukte_herbal_fasting_tea_1_images'
                }
            ]
        },

        einzelneprodukte_herbal_fasting_tea_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_herbal_fasting_tea',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Herbal Fasting Tea/LR-LIFETAKT_einzelne-produkte43.jpg'
                }
            ]
        },

        einzelneprodukte_protein_power: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'einzelneprodukte',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Potrein Power/LR-LIFETAKT_einzelne-produkte44.jpg',
                    infoImage: 'einzelneprodukte_protein_power_1_images'
                }
            ]
        },

        einzelneprodukte_protein_power_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_protein_power',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Potrein Power/LR-LIFETAKT_einzelne-produkte45.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Potrein Power/LR-LIFETAKT_einzelne-produkte46.jpg'
                }
            ]
        },

        einzelneprodukte_pro_balance: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'einzelneprodukte',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Pro Balance/LR-LIFETAKT_einzelne-produkte47.jpg',
                    infoImage: 'einzelneprodukte_pro_balance_1_images',
                    infoVideo: 'einzelneprodukte_pro_balance_1_videos',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Pro Balance/LR-LIFETAKT_einzelne-produkte47_1.jpg',
                    infoImage: 'einzelneprodukte_pro_balance_1_images',
                    infoVideo: 'einzelneprodukte_pro_balance_1_videos',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Pro Balance/LR-LIFETAKT_einzelne-produkte47_2.jpg',
                    infoImage: 'einzelneprodukte_pro_balance_1_images',
                    infoVideo: 'einzelneprodukte_pro_balance_1_videos',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Pro Balance/LR-LIFETAKT_einzelne-produkte47_3.jpg',
                    infoImage: 'einzelneprodukte_pro_balance_1_images',
                    infoVideo: 'einzelneprodukte_pro_balance_1_videos',
                }
            ]
        },

        einzelneprodukte_pro_balance_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_pro_balance',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Pro Balance/LR-LIFETAKT_einzelne-produkte48.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Pro Balance/LR-LIFETAKT_einzelne-produkte48_1.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Pro Balance/LR-LIFETAKT_einzelne-produkte48_2.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Pro Balance/LR-LIFETAKT_einzelne-produkte48_3.jpg'
                }
            ]
        },

        einzelneprodukte_figu_active: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'einzelneprodukte',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Figu Active/LR-LIFETAKT_einzelne-produkte49.jpg',
                    infoImage: 'einzelneprodukte_figu_active_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Figu Active/LR-LIFETAKT_einzelne-produkte54.jpg',
                    infoImage: 'einzelneprodukte_figu_active_2_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Figu Active/LR-LIFETAKT_einzelne-produkte57.jpg',
                    infoImage: 'einzelneprodukte_figu_active_3_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Figu Active/LR-LIFETAKT_einzelne-produkte62.jpg',
                    infoImage: 'einzelneprodukte_figu_active_4_images'
                }
            ]
        },

        einzelneprodukte_figu_active_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_figu_active',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Figu Active/LR-LIFETAKT_einzelne-produkte50.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Figu Active/LR-LIFETAKT_einzelne-produkte51.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Figu Active/LR-LIFETAKT_einzelne-produkte52.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Figu Active/LR-LIFETAKT_einzelne-produkte53.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Figu Active/LR-LIFETAKT_einzelne-produkte53_1.jpg'
                }
            ]
        },

        einzelneprodukte_figu_active_2_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_figu_active',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Figu Active/LR-LIFETAKT_einzelne-produkte55.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Figu Active/LR-LIFETAKT_einzelne-produkte56.jpg'
                }
            ]
        },

        einzelneprodukte_figu_active_3_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_figu_active',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Figu Active/LR-LIFETAKT_einzelne-produkte58.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Figu Active/LR-LIFETAKT_einzelne-produkte59.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Figu Active/LR-LIFETAKT_einzelne-produkte60.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Figu Active/LR-LIFETAKT_einzelne-produkte61.jpg'
                }
            ]
        },

        einzelneprodukte_figu_active_4_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_figu_active',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Figu Active/LR-LIFETAKT_einzelne-produkte63.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Figu Active/LR-LIFETAKT_einzelne-produkte64.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Figu Active/LR-LIFETAKT_einzelne-produkte65.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Figu Active/LR-LIFETAKT_einzelne-produkte66.jpg'
                }
            ]
        },

        einzelneprodukte_die_aloe_vera: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'einzelneprodukte',
            infoVideo: 'einzelneprodukte_die_aloe_vera_videos',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Produkte/Die Aloe Vera/LR-LIFETAKT_einzelne-produkte67.jpg',
                }
            ]
        },

        kopfbisfuss_lr_aloe_via_die_aloe_vera: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via',
            infoVideo: 'kopfbisfuss_lr_aloe_via_die_aloe_vera_video',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA2.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA3.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA4.jpg',
                }
            ]
        },


        kopfbisfuss_lr_aloe_via_special_care: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA5.jpg',
                    infoImage: 'kopfbisfuss_lr_aloe_via_special_care_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA9.jpg',
                    // infoImage: 'kopfbisfuss_lr_aloe_via_special_care_2_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA10.jpg',
                    infoImage: 'kopfbisfuss_lr_aloe_via_special_care_3_images'
                }
            ]
        },

        kopfbisfuss_lr_aloe_via_special_care_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via_special_care',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA6.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA7.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA8.jpg'
                }
            ]
        },

        kopfbisfuss_lr_aloe_via_special_care_3_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via_special_care',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA11.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA12.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA13.jpg'
                }
            ]
        },

        kopfbisfuss_lr_aloe_via_oral_care: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA39.jpg',
                    infoImage: 'kopfbisfuss_lr_aloe_via_oral_care_1_images'
                },
            ]
        },

        kopfbisfuss_lr_aloe_via_oral_care_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via_oral_care',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA40.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA41.jpg'
                }
            ]
        },

        kopfbisfuss_lr_aloe_via_hair_care: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via',
            infoVideo: 'kopfbisfuss_lr_aloe_via_hair_care_videos',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA42.jpg',
                    infoImage: 'kopfbisfuss_lr_aloe_via_hair_care_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA43.jpg',
                    infoImage: 'kopfbisfuss_lr_aloe_via_hair_care_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA44.jpg',
                    infoImage: 'kopfbisfuss_lr_aloe_via_hair_care_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA45.jpg',
                    infoImage: 'kopfbisfuss_lr_aloe_via_hair_care_1_images'
                },
            ]
        },

        kopfbisfuss_lr_aloe_via_hair_care_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via_hair_care',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA46.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA47.jpg'
                }
            ]
        },

        kopfbisfuss_lr_aloe_via_face_care: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA14.jpg',
                    infoImage: 'kopfbisfuss_lr_aloe_via_face_care_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA17.jpg',
                    infoImage: 'kopfbisfuss_lr_aloe_via_face_care_2_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA20.jpg',
                    infoImage: 'kopfbisfuss_lr_aloe_via_face_care_3_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA24.jpg',
                    infoImage: 'kopfbisfuss_lr_aloe_via_face_care_4_images'
                },
            ]
        },

        kopfbisfuss_lr_aloe_via_face_care_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via_face_care',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA15.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA16.jpg'
                }
            ]
        },

        kopfbisfuss_lr_aloe_via_face_care_2_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via_face_care',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA18.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA19.jpg'
                }
            ]
        },

        kopfbisfuss_lr_aloe_via_face_care_3_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via_face_care',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA21.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA22.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA23.jpg'
                }
            ]
        },

        kopfbisfuss_lr_aloe_via_face_care_4_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via_face_care',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA25.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA26.jpg'
                }
            ]
        },

        kopfbisfuss_lr_aloe_via_body_care: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA27.jpg',
                    infoImage: 'kopfbisfuss_lr_aloe_via_body_care_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA30.jpg',
                    infoImage: 'kopfbisfuss_lr_aloe_via_body_care_2_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA32.jpg',
                    infoImage: 'kopfbisfuss_lr_aloe_via_body_care_3_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA34.jpg',
                    infoImage: 'kopfbisfuss_lr_aloe_via_body_care_4_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA36.jpg',
                    infoImage: 'kopfbisfuss_lr_aloe_via_body_care_5_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA64.jpg',
                    infoImage: 'kopfbisfuss_lr_aloe_via_body_care_6_images'
                },
            ]
        },

        kopfbisfuss_lr_aloe_via_body_care_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via_body_care',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA28.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA29.jpg'
                }
            ]
        },

        kopfbisfuss_lr_aloe_via_body_care_2_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via_body_care',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA31.jpg'
                },
            ]
        },

        kopfbisfuss_lr_aloe_via_body_care_3_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via_body_care',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA33.jpg'
                },
            ]
        },

        kopfbisfuss_lr_aloe_via_body_care_4_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via_body_care',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA35.jpg'
                },

            ]
        },

        kopfbisfuss_lr_aloe_via_body_care_5_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via_body_care',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA37.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA38.jpg'
                }
            ]
        },

        kopfbisfuss_lr_aloe_via_body_care_6_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via_body_care',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA65.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA66.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA67.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA68.jpg'
                }
            ]
        },

        kopfbisfuss_lr_aloe_via_baby_kids_care: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA51.jpg',
                    infoImage: 'kopfbisfuss_lr_aloe_via_baby_kids_care_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA55.jpg',
                    infoImage: 'kopfbisfuss_lr_aloe_via_baby_kids_care_2_images'
                },
            ]
        },

        kopfbisfuss_lr_aloe_via_baby_kids_care_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via_baby_kids_care',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA52.jpg',
                },
                {

                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA53.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA54.jpg'
                }
            ]
        },

        kopfbisfuss_lr_aloe_via_baby_kids_care_2_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via_baby_kids_care',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA56.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA57.jpg'
                },
            ]
        },

        kopfbisfuss_lr_aloe_via_men_care: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA48.jpg',
                    infoImage: 'kopfbisfuss_lr_aloe_via_men_care_1_images'
                },
            ]
        },

        kopfbisfuss_lr_aloe_via_men_care_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via_men_care',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA49.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA50.jpg'
                }
            ]
        },

        kopfbisfuss_lr_aloe_via_sun_care: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA58.jpg',
                    infoImage: 'kopfbisfuss_lr_aloe_via_sun_care_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA59.jpg',
                    infoImage: 'kopfbisfuss_lr_aloe_via_sun_care_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA60.jpg',
                    infoImage: 'kopfbisfuss_lr_aloe_via_sun_care_1_images'
                },
            ]
        },

        kopfbisfuss_lr_aloe_via_sun_care_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via_sun_care',

            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA61.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA62.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Produkte/haut-und-haarpflege_LR ALOE VIA63.jpg'
                }
            ]
        },

        kopfbisfuss_lr_zeitgard_images: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'kopfbisfuss_lr_zeitgard',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD2.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD3.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD4.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD5.jpg',
                },
            ]
        },

        kopfbisfuss_lr_zeitgard_cleansing: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'kopfbisfuss_lr_zeitgard',
            infoVideo: 'kopfbisfuss_lr_zeitgard_cleansing_videos',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD6.jpg',
                    infoImage: 'kopfbisfuss_lr_zeitgard_cleansing_images'
                },
            ]
        },

        kopfbisfuss_lr_zeitgard_cleansing_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_zeitgard_cleansing',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD7.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD8.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD9.jpg',
                },
            ]
        },

        kopfbisfuss_lr_zeitgard_anti_age: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'kopfbisfuss_lr_zeitgard',
            infoVideo: 'kopfbisfuss_lr_zeitgard_anti_age_videos',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD10.jpg',
                    infoImage: 'kopfbisfuss_lr_zeitgard_anti_age_images'
                },
            ]
        },

        kopfbisfuss_lr_zeitgard_anti_age_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_zeitgard_anti_age',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD11.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD12.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD13.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD14.jpg',
                },
            ]
        },

        kopfbisfuss_lr_zeitgard_care: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'kopfbisfuss_lr_zeitgard',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD15.jpg',
                    infoImage: 'kopfbisfuss_lr_zeitgard_care_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD17.jpg',
                    infoImage: 'kopfbisfuss_lr_zeitgard_care_2_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD22.jpg',
                    infoImage: 'kopfbisfuss_lr_zeitgard_care_3_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD27.jpg',
                    infoImage: 'kopfbisfuss_lr_zeitgard_care_4_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD32.jpg',
                    infoImage: 'kopfbisfuss_lr_zeitgard_care_5_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD34.jpg',
                    infoImage: 'kopfbisfuss_lr_zeitgard_care_6_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD38.jpg',
                    infoImage: 'kopfbisfuss_lr_zeitgard_care_7_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD42.jpg',
                    infoImage: 'kopfbisfuss_lr_zeitgard_care_8_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD45.jpg',
                    infoImage: 'kopfbisfuss_lr_zeitgard_care_9_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD47.jpg',
                    infoImage: 'kopfbisfuss_lr_zeitgard_care_10_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD49.jpg',
                    infoImage: 'kopfbisfuss_lr_zeitgard_care_11_images',
                    infoVideo: 'kopfbisfuss_lr_zeitgard_care_11_videos'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD50.jpg',
                    infoImage: 'kopfbisfuss_lr_zeitgard_care_11_images',
                    infoVideo: 'kopfbisfuss_lr_zeitgard_care_11_videos'

                },
            ]
        },

        kopfbisfuss_lr_zeitgard_care_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_zeitgard_care',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD16.jpg',
                },
            ]
        },

        kopfbisfuss_lr_zeitgard_care_2_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_zeitgard_care',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD18.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD19.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD20.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD21.jpg',
                },
            ]
        },

        kopfbisfuss_lr_zeitgard_care_3_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_zeitgard_care',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD23.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD24.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD25.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD26.jpg',
                },
            ]
        },

        kopfbisfuss_lr_zeitgard_care_4_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_zeitgard_care',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD28.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD29.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD30.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD31.jpg',
                },
            ]
        },

        kopfbisfuss_lr_zeitgard_care_5_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_zeitgard_care',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD33.jpg',
                }
            ]
        },

        kopfbisfuss_lr_zeitgard_care_6_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_zeitgard_care',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD35.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD36.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD37.jpg',
                },
            ]
        },

        kopfbisfuss_lr_zeitgard_care_7_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_zeitgard_care',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD39.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD40.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD41.jpg',
                },
            ]
        },

        kopfbisfuss_lr_zeitgard_care_8_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_zeitgard_care',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD43.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD44.jpg',
                },
            ]
        },

        kopfbisfuss_lr_zeitgard_care_9_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_zeitgard_care',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD46.jpg',
                },
            ]
        },

        kopfbisfuss_lr_zeitgard_care_10_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_zeitgard_care',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD48.jpg',
                },
            ]
        },

        kopfbisfuss_lr_zeitgard_care_11_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_zeitgard_care',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD51.jpg',
                },
            ]
        },

        kopfbisfuss_lr_microsilver_plus: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'kopfbisfuss',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/MICROSILVER/haut-und-haarpflege_MICROSILVER.jpg',
                    infoImage: 'kopfbisfuss_lr_microsilver_plus_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/MICROSILVER/haut-und-haarpflege_MICROSILVER5.jpg',
                    infoImage: 'kopfbisfuss_lr_microsilver_plus_2_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/MICROSILVER/haut-und-haarpflege_MICROSILVER8.jpg',
                    infoImage: 'kopfbisfuss_lr_microsilver_plus_3_images',
                    infoVideo: 'kopfbisfuss_lr_microsilver_plus_3_videos',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/MICROSILVER/haut-und-haarpflege_MICROSILVER13.jpg',
                    infoImage: 'kopfbisfuss_lr_microsilver_plus_4_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/MICROSILVER/haut-und-haarpflege_MICROSILVER16.jpg',
                    infoImage: 'kopfbisfuss_lr_microsilver_plus_5_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/MICROSILVER/haut-und-haarpflege_MICROSILVER20.jpg',
                    infoImage: 'kopfbisfuss_lr_microsilver_plus_6_images',
                    infoVideo: 'kopfbisfuss_lr_microsilver_plus_6_videos',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/MICROSILVER/MICROSILVER_careSET_Seite22.jpg',
                },
            ]
        },

        kopfbisfuss_lr_microsilver_plus_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_microsilver_plus',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/MICROSILVER/haut-und-haarpflege_MICROSILVER2.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/MICROSILVER/haut-und-haarpflege_MICROSILVER3.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/MICROSILVER/haut-und-haarpflege_MICROSILVER4.jpg',
                },
            ]
        },


        kopfbisfuss_lr_microsilver_plus_2_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_microsilver_plus',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/MICROSILVER/haut-und-haarpflege_MICROSILVER6.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/MICROSILVER/haut-und-haarpflege_MICROSILVER7.jpg',
                },
            ]
        },


        kopfbisfuss_lr_microsilver_plus_3_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_microsilver_plus',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/MICROSILVER/haut-und-haarpflege_MICROSILVER9.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/MICROSILVER/haut-und-haarpflege_MICROSILVER10.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/MICROSILVER/haut-und-haarpflege_MICROSILVER11.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/MICROSILVER/haut-und-haarpflege_MICROSILVER12.jpg',
                },

            ]
        },

        kopfbisfuss_lr_microsilver_plus_4_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_microsilver_plus',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/MICROSILVER/haut-und-haarpflege_MICROSILVER14.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/MICROSILVER/haut-und-haarpflege_MICROSILVER15.jpg',
                },
            ]
        },

        kopfbisfuss_lr_microsilver_plus_5_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_microsilver_plus',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/MICROSILVER/haut-und-haarpflege_MICROSILVER17.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/MICROSILVER/haut-und-haarpflege_MICROSILVER18.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/MICROSILVER/haut-und-haarpflege_MICROSILVER19.jpg',
                },
            ]
        },

        kopfbisfuss_lr_microsilver_plus_6_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_microsilver_plus',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/MICROSILVER/haut-und-haarpflege_MICROSILVER21.jpg',
                },
            ]
        },

        duefte_starbox: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'duefte',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte2.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte3.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte4.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte5.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte6.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte7.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte8.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte9.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte10.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte11.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte12.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte13.jpg',
                },
            ]
        },

        duefte_herren_stars: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'duefte',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte38_1.jpg',
                    infoImage: 'duefte_herren_stars_0_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte39.jpg',
                    infoImage: 'duefte_herren_stars_1_images',
                    infoVideo: 'duefte_herren_stars_1_videos'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte41.jpg',
                    infoImage: 'duefte_herren_stars_2_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte43.jpg',
                    infoImage: 'duefte_herren_stars_3_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte45.jpg',
                    infoImage: 'duefte_herren_stars_4_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte47.jpg',
                    infoImage: 'duefte_herren_stars_5_images'
                },
            ]
        },

        duefte_herren_stars_0_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'duefte_herren_stars',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte38_2.jpg',
                    infoImage: 'duefte_herren_stars_1_images'
                },
            ]
        },

        duefte_herren_stars_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'duefte_herren_stars',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte40.jpg',
                    infoImage: 'duefte_herren_stars_1_images'
                },
            ]
        },

        duefte_herren_stars_2_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'duefte_herren_stars',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte42.jpg',
                    infoImage: 'duefte_herren_stars_1_images'
                },
            ]
        },

        duefte_herren_stars_3_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'duefte_herren_stars',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte44.jpg',
                    infoImage: 'duefte_herren_stars_1_images'
                },
            ]
        },

        duefte_herren_stars_4_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'duefte_herren_stars',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte46.jpg',
                    infoImage: 'duefte_herren_stars_1_images'
                },
            ]
        },

        duefte_herren_stars_5_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'duefte_herren_stars',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte48.jpg',
                    infoImage: 'duefte_herren_stars_1_images'
                },
            ]
        },

        duefte_herren_individuals: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'duefte',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte49.jpg',
                    infoImage: 'duefte_herren_individuals_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte52.jpg',
                    infoImage: 'duefte_herren_individuals_2_images'
                }
            ]
        },

        duefte_herren_individuals_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'duefte_herren_individuals',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte50.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte51.jpg',
                },
            ]
        },

        duefte_herren_individuals_2_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'duefte_herren_individuals',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte53.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte54.jpg',
                },
            ]
        },

        duefte_herren_classics: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'duefte',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte55.jpg',
                    infoImage: 'duefte_herren_classics_1_images'
                },
            ]
        },

        duefte_herren_classics_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'duefte_herren_classics',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte56.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte57.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte58.jpg',
                },
            ]
        },

        duefte_damen_stars: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'duefte',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte13_1.jpg',
                    infoImage: 'duefte_damen_stars_0_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte14.jpg',
                    infoImage: 'duefte_damen_stars_1_images',
                    infoVideo: 'duefte_damen_stars_1_videos'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte16.jpg',
                    infoImage: 'duefte_damen_stars_2_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte18.jpg',
                    infoImage: 'duefte_damen_stars_3_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte20.jpg',
                    infoImage: 'duefte_damen_stars_4_images'
                },
            ]
        },

        duefte_damen_stars_0_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'duefte_damen_stars',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte13_2.jpg',
                },
            ]
        },

        duefte_damen_stars_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'duefte_damen_stars',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte15.jpg',
                },
            ]
        },

        duefte_damen_stars_2_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'duefte_damen_stars',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte17.jpg',
                },
            ]
        },

        duefte_damen_stars_3_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'duefte_damen_stars',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte19.jpg',
                },
            ]
        },

        duefte_damen_stars_4_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'duefte_damen_stars',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte21.jpg',
                },
            ]
        },

        duefte_damen_essenzen: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'duefte',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte22.jpg',
                    infoImage: 'duefte_damen_essenzen_1_images'
                },
            ]
        },

        duefte_damen_essenzen_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'duefte_damen_essenzen',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte23.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte24.jpg',
                },
            ]
        },

        duefte_damen_individuals: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'duefte',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte25.jpg',
                    infoImage: 'duefte_damen_individuals_1_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte28.jpg',
                    infoImage: 'duefte_damen_individuals_2_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte31.jpg',
                    infoImage: 'duefte_damen_individuals_3_images'
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte33.jpg',
                    infoImage: 'duefte_damen_individuals_4_images'
                },
            ]
        },

        duefte_damen_individuals_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'duefte_damen_individuals',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte26.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte27.jpg',
                },
            ]
        },

        duefte_damen_individuals_2_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'duefte_damen_individuals',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte29.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte30.jpg',
                },
            ]
        },

        duefte_damen_individuals_3_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'duefte_damen_individuals',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte32.jpg',
                },
            ]
        },

        duefte_damen_individuals_4_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'duefte_damen_individuals',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte34.jpg',
                },
            ]
        },

        duefte_damen_classics: {
            backDestinationName: 'tilepage',
            backDestinationParam: 'duefte',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte35.jpg',
                    infoImage: 'duefte_damen_classics_1_images'
                },
            ]
        },

        duefte_damen_classics_1_images: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'duefte_damen_classics',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte36.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte37.jpg',
                },
                {
                    type: 'image',
                    path: 'data/zeile-3_5_Damen_und_Herrenduefte/Produkte/damen_und_herren_duefte38.jpg',
                },
            ]
        },

        tiergesundheit: {
            backDestinationName: 'root',
            backDestinationParam: '',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-2_4_Tiergesundheit/LR_tiergesundheit.jpg'
                }
            ]
        },

        monatsangebote: {
            backDestinationName: 'root',
            backDestinationParam: '',
            slides: [
                {
                    type: 'image',
                    path: 'data/zeile-2_5_MonatsAngebote/LR_aktuelle-monatsangebote_AUGUST_2021_1.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-2_5_MonatsAngebote/LR_aktuelle-monatsangebote_AUGUST_2021_2.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-2_5_MonatsAngebote/LR_aktuelle-monatsangebote_AUGUST_2021_3.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-2_5_MonatsAngebote/LR_aktuelle-monatsangebote_AUGUST_2021_4.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-2_5_MonatsAngebote/LR_aktuelle-monatsangebote_AUGUST_2021_5.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-2_5_MonatsAngebote/LR_aktuelle-monatsangebote_AUGUST_2021_6.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-2_5_MonatsAngebote/LR_aktuelle-monatsangebote_AUGUST_2021_7.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-2_5_MonatsAngebote/LR_aktuelle-monatsangebote_AUGUST_2021_8.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-2_5_MonatsAngebote/LR_aktuelle-monatsangebote_AUGUST_2021_9.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-2_5_MonatsAngebote/LR_aktuelle-monatsangebote_AUGUST_2021_10.jpg'
                },
                {
                    type: 'image',
                    path: 'data/zeile-2_5_MonatsAngebote/LR_aktuelle-monatsangebote_AUGUST_2021_11.jpg'
                }
            ]
        },

    }
}